var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTpmycourseicon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21431 0.396449C14.1479 0.396449 18.1452 4.39373 18.1452 9.3273C18.1452 14.2609 14.1479 18.2582 9.21431 18.2582C4.28073 18.2582 0.283453 14.2609 0.283453 9.3273C0.283453 4.39373 4.28073 0.396449 9.21431 0.396449ZM9.21431 16.5296C13.1756 16.5296 16.4166 13.3246 16.4166 9.3273C16.4166 5.36604 13.1756 2.125 9.21431 2.125C5.21703 2.125 2.01201 5.36604 2.01201 9.3273C2.01201 13.3246 5.21703 16.5296 9.21431 16.5296ZM11.411 12.7844L8.35003 10.5517C8.242 10.4797 8.20599 10.3356 8.20599 10.2276V4.28569C8.20599 4.06962 8.38604 3.85355 8.63813 3.85355H9.79049C10.0066 3.85355 10.2226 4.06962 10.2226 4.28569V9.39933L12.5994 11.1639C12.8155 11.3079 12.8515 11.56 12.7074 11.7761L12.0232 12.6764C11.8792 12.8924 11.6271 12.9285 11.411 12.7844Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpmycourseicon2);
export default __webpack_public_path__ + "static/media/tpmycourseicon2.9bddb1cf6dc3de291abb7466416f50ff.svg";
export { ForwardRef as ReactComponent };